import React, { ReactNode, createContext, useContext, useEffect, useState } from 'react';

interface PlatformContextProps {
	platformName: string;
	isEyeQMarketplace: boolean;
	isAtom: boolean;
	isZeus: boolean;
	isIpl: boolean;
}

const PlatformContext = createContext<PlatformContextProps | null>(null);

interface PlatformProviderProps {
	children: ReactNode;
}

export const PlatformProvider: React.FC<PlatformProviderProps> = ({ children }) => {
	const [platformName, setPlatformName] = useState<string>('Zeus');
	const [isEyeQMarketplace, setIsEyeQMarketplace] = useState<boolean>(false);
	const [isAtom, setIsAtom] = useState<boolean>(false);
	const [isZeus, setIsZeus] = useState<boolean>(false);
	const [isIpl, setIsIpl] = useState<boolean>(false);

	useEffect(() => {
		const hostUrl = window.location.host.split('.');
		if (hostUrl.includes('eyeqmarketplace')) {
			setPlatformName('EyeQ');
			setIsEyeQMarketplace(true);
		}
		if (hostUrl.includes('apollo-uat') || hostUrl.includes('atom')) {
			setPlatformName('ATOM');
			setIsAtom(true);
		}
		if (hostUrl.includes('ipl')) {
			setIsIpl(true);
		}
		if (hostUrl.includes('zeus') || (hostUrl.includes('app') && !hostUrl.includes('apollo-uat'))) {
			setPlatformName('Zeus');
			setIsZeus(true);
		}
	}, []);

	return (
		<PlatformContext.Provider value={{ platformName, isEyeQMarketplace, isAtom, isIpl, isZeus }}>
			{children}
		</PlatformContext.Provider>
	);
};

export const usePlatform = (): PlatformContextProps => {
	const context = useContext(PlatformContext);
	if (!context) {
		throw new Error('usePlatform must be used within a PlatformProvider');
	}
	return context;
};

export {};
